import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Col, DatePicker, Form, Input, notification, Radio, Row, Spin } from 'antd';
import moment from 'moment';

import * as consultantController from '../../../../../../services/api/consultant';
import './ConsultantForm.scss';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

export class ConsultantForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        };
    }

    handleSubmit(e) {
        const { history, match, form } = this.props;
        const consultantId = match.params.consultantId;
        const isCreateNewConsultant = match.params.consultantId === undefined;

        e.preventDefault();
        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                (isCreateNewConsultant ? consultantController.createConsultant(values) : consultantController.updateConsultant(consultantId, values))
                    .then((res) => res.json())
                    .then((json) => {
                        this.setState({ isLoading: false });
                        history.push('/dashboard/admin/consultant');
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isLoading: false });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    componentDidMount() {
        const { match, form } = this.props;
        const consultantId = match.params.consultantId;

        if (consultantId === undefined) {
            form.resetFields();
        } else {
            this.setState({ isLoading: true });

            consultantController.getConsultant(consultantId)
                .then((res) => res.json())
                .then((json) => {
                    const { username, name, email, is_admin, joined_at } = json
                    form.setFieldsValue({ username, name, email, is_admin, joined_at: moment(joined_at) });
                    this.setState({ isLoading: false });
                })
        }
    }

    render() {
        const { history, match, form } = this.props;
        const { isLoading } = this.state;
        const { getFieldDecorator } = form;
        const isCreateNewConsultant = match.params.consultantId === undefined;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        return (
            <Spin spinning={isLoading}>
            	<Form className="ConsultantForm" onSubmit={(e) => this.handleSubmit(e)}>
            		<Row gutter={32}>
            			<Col span={12}>
            				<FormItem {...formItemLayout} label="Username">
            					{
            						getFieldDecorator('username', {
										rules: [{
											required: true,
                                            message: 'This field is required.'
										}],
									})(
										<Input placeholder="Input Username(for Login)" />
									)
								}
            				</FormItem>
            			</Col>
            			<Col span={12}>
            				<FormItem {...formItemLayout} label="Name">
            					{
            						getFieldDecorator('name', {
										rules: [{
											required: true,
                                            message: 'This field is required.'
										}],
									})(
										<Input placeholder="Input Consultant Name" />
									)
								}
            				</FormItem>
            			</Col>
            		</Row>
            		<Row gutter={32}>
            			<Col span={12}>
            				<FormItem {...formItemLayout} label={isCreateNewConsultant ? 'Password' : 'New Password'}>
            					{
            						getFieldDecorator('password', {
										rules: [{
											required: isCreateNewConsultant,
                                            message: 'This field is required.'
										}],
									})(
										<Input type="password" placeholder="Input Password(for Login)" />
									)
								}
            				</FormItem>
            			</Col>
            			<Col span={12}>
            				<FormItem {...formItemLayout} label="Email">
            					{
            						getFieldDecorator('email', {
										rules: [{
											required: true,
                                            message: 'This field is required.'
										}],
									})(
										<Input placeholder="Input Consultant Email" />
									)
								}
            				</FormItem>
            			</Col>
            		</Row>
            		<Row gutter={32}>
            			<Col span={12}>
            				<FormItem {...formItemLayout} label="Is Admin?">
            					{
            						getFieldDecorator('is_admin', {
										rules: [{
											required: true,
                                            message: 'This field is required.',
										}],
                                        initialValue: false
									})(
										<RadioGroup>
											<Radio value={true}>Yes</Radio>
											<Radio value={false}>No</Radio>
										</RadioGroup>
									)
								}
            				</FormItem>
            			</Col>
            			<Col span={12}>
            				<FormItem {...formItemLayout} label="Joined At">
            					{
            						getFieldDecorator('joined_at', {
										rules: [{
											required: true,
                                            message: 'This field is required.'
										}],
                                        initialValue: moment()
									})(
										<DatePicker/>
									)
								}
            				</FormItem>
            			</Col>
            		</Row>
            		<Row>
            			<FormItem>
							<Button onClick={(e) => history.push('/dashboard/admin/consultant')}>Back</Button>
							{' '}
							<Button type="primary" htmlType="submit">{isCreateNewConsultant ? 'Create' : 'Update'}</Button>
            			</FormItem>
            		</Row>
            	</Form>
        	</Spin>
        );
    }
}

const WrappedConsultantForm = Form.create()(ConsultantForm);
export default withRouter(WrappedConsultantForm);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ConsultantManagementPage/components/ConsultantForm/ConsultantForm.js